import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import DateRangeSelector from "../../Ui-Elemnent/DateRange";
import CalenderSelctor from "../../Ui-Elemnent/Calender";
import { CSVLink } from "react-csv";
import format from 'date-fns/format';
import ScaleLoaderItem from "../../Ui-Elemnent/ScaleLoader";
import useTspwardData from "./data-fetch/fetch-wardwisedetails";

export default function WardPage({
  city,
  range,
  setRange,
}: {
  city: string;
  range: any;
  setRange: any;
}) {
  const { wardNumber } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const toDate = query.get("toDate");
  const fromDate = query.get("fromDate"); // ✅ added
  const cityQuery = query.get("city");
  const today = new Date()

  const [calendar, setCalendar] = useState<any>(range?.[0]?.endDate);
  const [selectdDate, setSelectedDate] = useState(format(new Date(), "dd/MM/yyyy"));
  const navigate = useNavigate();
    console.log("selectdDate : ",selectdDate)
  // ✅ useMemo to avoid re-creating rowHeading every render
  const rowHeading = useMemo(
  () => [
    { heading: "Ward No.", key: "wardNumber", isChecked: true },
    { heading: "TSP", key: "tsp", isChecked: true },
    { heading: "Cleaned TSP", key: "isScan", isChecked: true },
    { heading: "Tsp Name", key: "propertyName", isChecked: true },
    { heading: "Time", key: "time", isChecked: true },
    { heading: "Vehicle used", key: "vehiclID", isChecked: true },
    { heading: "No of Bags In", key: "bags", isChecked: true, subHeaders: [
        { heading: "Dry", key: "dry" },
        { heading: "Wet", key: "wet" },
        { heading: "Bio Medical", key: "bioMedical" },
        { heading: "Hazardous", key: "hazardous" },
        { heading: "Mixed", key: "mixed" },
        { heading: "Total", key: "total" },
      ]
    },
  ],
  []
);

  const [filteredColumn, setFilteredColumn] = useState<any[]>([]);

  useEffect(() => {
    setFilteredColumn(rowHeading);
  }, [rowHeading]);


  // ✅ Fixed useTspwardData call
  const { tspwardData, loading } = useTspwardData({
    city: city ?? "",
    toDate: selectdDate ?? "",
    wardNumber: wardNumber ?? "",
  });

  const data: any = tspwardData;
  console.log("tspwardData  list : ",tspwardData)

  useEffect(()=>{
        setSelectedDate(format(new Date(calendar), "dd/MM/yyyy"))
     },[calendar])
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto ">
        <div className="flex justify-start py-2 pl-2 ">
          <div className="flex justify-end">
            {/* <DateRangeSelector range={range} setRange={setRange} /> */}
            {<CalenderSelctor calendar={calendar} setCalendar={setCalendar} />}

            <div className="flex items-center border border-gray rounded-md mr-4 h-12">
              <CSVLink
                data={data?.length !== 0 && data !== undefined ? data : ""}
                filename={`Tsp_Report_${city}_${toDate}_to.csv`}
                className="text-sm font-medium text-gray-700 hover:text-gray-900"
              >
                <button className="relative z-0 inline-flex text-sm rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1">
                  <span className="relative inline-flex items-center px-3 py-3 space-x-2 text-sm font-medium text-gray-600 bg-white rounded-md sm:py-2">
                    <div>
                      <svg
                        className="w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                    </div>
                    <div className="hidden sm:block">Download</div>
                  </span>
                </button>
              </CSVLink>
            </div>
          </div>
          {/* 🔙 Back Button */}
            <button
                onClick={() => navigate(-1)}
                className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg shadow"
            >
                ⬅ Back
            </button>
        </div>

        <div className="p-1.5 w-full inline-block align-middle">
          <div className="overflow-hidden border rounded-lg">
            {loading ? (
              <ScaleLoaderItem loading={loading} />
            ) : (
              <table className="min-w-full divide-y divide-recity">
                <thead className="bg-recity">
                  {/* First row - main headers */}
                  <tr>
                    {filteredColumn.map((item, index) => (
                      <th
                        key={index}
                        colSpan={item.key === "bags" ? item.subHeaders?.length || 1 : 1}
                        className="px-4 py-2 text-l font-bold text-center text-white uppercase border"
                      >
                        {item.isChecked && item.heading}
                      </th>
                    ))}
                  </tr>
                  {/* Second row - sub headers for bags */}
                  <tr>
                    {filteredColumn.map((item, index) =>
                      item.key === "bags" && item.subHeaders
                        ? item.subHeaders.map((sub: { heading: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; }, subIndex: any) => (
                            <th
                              key={`${index}-${subIndex}`}
                              className="px-4 py-2 text-sm font-bold text-center text-white uppercase border"
                            >
                              {sub.heading}
                            </th>
                          ))
                        : item.key !== "bags" && (
                            <th
                              key={index}
                              className="px-4 py-2 text-sm font-bold text-center text-white uppercase border"
                            >
                              {/* Empty so it aligns */}
                            </th>
                          )
                    )}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data.map((row: any, rowIndex: number) => (
                    <tr key={rowIndex} className="text-center">
                      <td className="px-4 py-2 border">{row.wardNumber}</td>
                      <td className="px-4 py-2 border">{row.tsp}</td>
                      <td className="px-4 py-2 border">{row.isScan ? "Yes" : "No"}</td>
                      <td className="px-4 py-2 border">{row.propertyName || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.time || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.vehiclID || "N/A"}</td>

                      {/* ✅ Bags sub-columns */}
                      <td className="px-4 py-2 border">{row.bags?.dry || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.bags?.wet || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.bags?.bioMedical || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.bags?.hazardous || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.bags?.mixed || "N/A"}</td>
                      <td className="px-4 py-2 border">{row.bags?.total || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>

              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
